import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { ClockClockwise, CalendarBlank } from '@phosphor-icons/react'

import { TRIGGER_OPTIONS } from '../../helpers'

const SelectInspectionTrigger = ({
  onNext = () => {},
  onBack = () => {},
  onSelect = () => {},
  value = '',
}) => {
  const { t } = useTranslation(['internal-inspections', 'common'])
  const options = [
    {
      name: TRIGGER_OPTIONS.ONE_TIME,
      title: t('internal-inspections:frequency.oneTime'),
      icon: <ClockClockwise />,
    },
    {
      name: TRIGGER_OPTIONS.RECURRING,
      title: t('internal-inspections:navbar.recurring'),
      icon: <CalendarBlank />,
    },
  ]

  return (
    <React.Fragment>
      <div className="inspections-modal-content">
        <div className="inspections-card-items">
          <div className="inspections-card-items__wrapper">
            {options.map((option) => (
              <div
                onClick={() => onSelect(option.name)}
                className={`inspections-card-item ${option.name === value ? 'selected' : ''}`}
                key={option.name}
              >
                {option.icon}
                <span>{option.title}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="inspections-modal-actions">
        <button className="button button-gray" onClick={onBack}>
          {t('common:actions.cancel')}
        </button>
        <button className="button button-primary auto-width" onClick={onNext} disabled={!value}>
          {t('internal-inspections:shared.next')}
        </button>
      </div>
    </React.Fragment>
  )
}

SelectInspectionTrigger.propTypes = {
  onNext: PropTypes.func,
  onBack: PropTypes.func,
  onSelect: PropTypes.func,
  value: PropTypes.string,
}

export default SelectInspectionTrigger
